import React from 'react';

import { ReactComponent as ReviewRatingSvg } from '@/assets/icons/hotel/reward.svg';
import { UncontrolledTooltip } from 'reactstrap';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const bgSvg = require('@/assets/icons/hotel/reward.svg');
type Props = {
  rate: number | null | undefined;
};

export default function HotelRewardRating({ rate }: Props) {
  const ref = React.useRef();
  if (!rate) {
    return null;
  }
  const roundedRate = Number(Math.round(rate * 10) / 10).toFixed(1);

  return (
    <div>
      <div className="row x-gap-10 y-gap-10 justify-end items-center md:justify-start">
        <div className="col-auto">
          <div className="text-12 lh-14 fw-400">Traveler Reviews</div>
          <div className="text-12 lh-14 fw-400">
            from Jalan.net
            <FontAwesomeIcon ref={ref as any} icon={faCircleInfo} className="text-blue-1 font-16 ml-5" />
          </div>
        </div>
        <div className="col-auto">
          <div className="flex-center text-white fw-600 text-14 size-40 rounded-8" style={{ backgroundColor: '#ff9800' }}>
            {roundedRate}
          </div>
        </div>
      </div>

      <UncontrolledTooltip target={ref as any}>
        <div className="px-10 py-10">
          Ratings are shown on a scale of 1 to 5, based on the reviews by guests who made reservations through Jalan.net and have actually stayed at
          the hotel. Ratings are average scores for the following categories; "Room", "Breakfast", "Dinner", "Bathroom", "Customer Service",
          "Cleanliness" and "Overall Rating", posted over the past year on a daily basis."
        </div>
      </UncontrolledTooltip>
    </div>
  );
}
